import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

const ModuleVersionDependenciesTableNameCell = <T extends { id: string }>({
  item: dependency,
  ...cellProps
}: TableSimpleCellProps<T>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{dependency.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default ModuleVersionDependenciesTableNameCell;
